import {
    GET_GL_ACCOUNTS_CLOSING,
    CREATE_ACCOUNTS_CLOSING,
    CLEAR_ACCOUNTS_CLOSING_STATE,
} from '../../index.types';


export function getGlAccountsClosing(data) {
    return {
        type: GET_GL_ACCOUNTS_CLOSING,
        data
    }
}

export function createAccountsClosing(data) {
    return {
        type: CREATE_ACCOUNTS_CLOSING,
        data
    }
}

export function clearAccountsClosingState() {
    return {
        type: CLEAR_ACCOUNTS_CLOSING_STATE
    }
}
